const filter = [
  {text: 'Название', value: 'name'},
  {text: 'Пакет', value: 'package'}
];

const sort = [
  {text: 'По названию', value: 'name', type: 'asc', default: true},
  {text: 'По названию', value: 'name', type: 'desc'}
];

export { filter, sort };
